import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class SetupService {

  constructor(private http: HttpClient) { }

  getAllInventoryGroups() {
    return this.http.get<any>(`${environment.coreUrl}Group`);
  }

  getAllDiscountTypes(groupId) {
    return this.http.get<any>(`${environment.inventoryURl}Type?groupId=${groupId}`);
  }

  //Behavior Subject for Payment Term
  private paymentTerm = new BehaviorSubject('');

  getPaymentTerm(): Observable<any> {
    return this.paymentTerm.asObservable();
  }

  setPaymentTerm(term) {
    this.paymentTerm.next(term);
  }

  //Behavior Subject for Payment Method
  private paymentMethod = new BehaviorSubject('');

  getPaymentMethod(): Observable<any> {
    return this.paymentMethod.asObservable();
  }

  setPaymentMethod(method) {
    this.paymentMethod.next(method);
  }

  //Behavior Subject for Shipping Term
  private shippingTerm = new BehaviorSubject('');

  getShippingTerm(): Observable<any> {
    return this.shippingTerm.asObservable();
  }

  setShippingTerm(term) {
    this.shippingTerm.next(term);
  }

  //Behavior Subject for Shipping Term
  private uom = new BehaviorSubject('');

  getUom(): Observable<any> {
    return this.uom.asObservable();
  }

  setUom(term) {
    this.uom.next(term);
  }

  //Behavior Subject for FOB Point
  private FOB = new BehaviorSubject('');

  getFOBPoint(): Observable<any> {
    return this.FOB.asObservable();
  }

  setFOB(point) {
    this.FOB.next(point);
  }

  //Behavior Subject for Shipping Method
  private shippingMethod = new BehaviorSubject('');

  getShippingMethod(): Observable<any> {
    return this.shippingMethod.asObservable();
  }

  setShippingMethod(method) {
    this.shippingMethod.next(method);
  }

   //Behavior Subject for Order Source
   private orderSource = new BehaviorSubject('');

   getOrderSource(): Observable<any> {
     return this.orderSource.asObservable();
   }
 
   setOrderSource(source) {
     this.orderSource.next(source);
   }

   //Behavior Subject for Discount
   private discount = new BehaviorSubject('');

   getDiscount(): Observable<any> {
     return this.discount.asObservable();
   }
 
   setDiscount(discount) {
     this.discount.next(discount);
   }

   //Behavior Subject for AdditionalFee
   private AdditionalFee = new BehaviorSubject('');

   getAdditionalFees(): Observable<any> {
     return this.AdditionalFee.asObservable();
   }
 
   setAdditionalFee(AdditionalFee) {
     this.AdditionalFee.next(AdditionalFee);
   }

    //Behavior Subject for Tax Rate
    private tax = new BehaviorSubject('');

    getTax(): Observable<any> {
      return this.tax.asObservable();
    }
  
    setTax(rate) {
      this.tax.next(rate);
    }

    //Behavior Subject for Pack Box
    private box = new BehaviorSubject('');
    getPackBox(): Observable<any> {
      return this.box.asObservable();

    }
    setPackBox(term) {
      this.box.next(term);
    }

    getAllFinancialAccounts(): Observable<any> {
      return this.http.get<any>(`${environment.financeURl}FinancialAccount/GetFinancialAccounts`);
  }

    checkDeleteStatus(deleteId: number, module: string, index?:number): Observable<any>{
      let params = new HttpParams();
      params = module=='paymentTerm' ? params.append('paymentTermId', deleteId):  params ;
      params = module=='paymentTerm' ? params.append('isVendorField', index==2):  params;
      params = module=='paymentMethod' ? params.append('paymentMethodId', deleteId):  params;
      params = module=='paymentMethod' ? params.append('isVendorField', index==3):  params;
      params = module=='shippingMethod' ? params.append('shippingMethodId', deleteId):  params;
      params = module=='shippingTerm' ? params.append('shippingTermId', deleteId):  params;
      params = module=='discount' ? params.append('discountId', deleteId):  params;
      params = module=='addfees' ? params.append('additionalId', deleteId):  params;
      params = module=='taxRate' ? params.append('taxId', deleteId):  params;
      return this.http.get<any>(`${environment.inventoryURl}InventoryCustomRule/CheckFieldAssociation`, {params})
    }
}
